import React, { useState, useCallback } from "react";
import Button from "@mui/material/Button";
import CssBaseline from "@mui/material/CssBaseline";
import TextField from "@mui/material/TextField";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import Paper from "@mui/material/Paper";
import CryptoJS from "crypto-js";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogActions from "@mui/material/DialogActions";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogTitle from "@mui/material/DialogTitle";
import Copyright from "./pages/components/Copyright";
import LoadingButton from "@mui/lab/LoadingButton";
import LogoLogin from "./img/logo_login.png";
import BKGLogin from "./img/img-tela-login.png";
import popImg from "./img/popup.png";
import server from "./functions/server";
import MediaQuery from "react-responsive";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import PhoneIcon from "@mui/icons-material/Phone";
import SupportIcon from "@mui/icons-material/Support";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import BuildIcon from "@mui/icons-material/Build";
import RemoveRedEyeIcon from "@mui/icons-material/RemoveRedEye";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { getCookieConsentValue } from "react-cookie-consent";
import { cookiesName } from "./utils/cookies";
import Cookies from "js-cookie";
import { supportNumber } from "./utils/supportNumber";
import { InputAdornment } from "@mui/material";

const theme = createTheme({
  palette: {
    mode: "light",
  },
});

const modalData = {
  erro: "O CNPJ/CPF e/ou a senha inserida estão incorretos.",
  recupera_senha:
    "Digite o seu CNPJ/CPF no campo abaixo. Ao confirmar, uma senha temporária será enviada ao e-mail cadastrado com o CNPJ fornecido.",
  cnpj_nao_reg: "O CNPJ/CPF inserido não está cadastrado no sistema.",
  email_enviado:
    "E-mail foi enviado com sucesso. Verifique sua caixa de entrada.",
};

const SignInSide = () => {
  const [open, setOpen] = useState(false);
  const [openNovo, setOpenNovo] = useState(true);
  const [descricao, setDescricao] = useState("");
  const [perdiSenhaCNPJ, setPerdiSenhaCNPJ] = useState("");
  const [loading, setLoading] = useState(false);
  const [showCnpjField, setShowCnpjField] = useState(false);
  const [modalButtons, setModalButtons] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const openModal = () => setOpen(true);
  const closeModal = () => {
    setOpen(false);
    setLoading(false);
    setShowCnpjField(false);
    setDescricao("");
  };

  const handleSubmit = useCallback((event) => {
    setLoading(true);
    event.preventDefault();

    const data = new FormData(event.currentTarget);

    let username = data.get("cnpj");
    if (window?.clarity) {
      window.clarity("identify", username, null, null, username);

      const consent = getCookieConsentValue(cookiesName);
      const cookieAccepted = consent ? "granted" : "denied";

      window.clarity("consentv2", {
        ad_storage: cookieAccepted,
        analytics_storage: cookieAccepted,
      });
    }

    username = username
      .replaceAll("-", "")
      .replaceAll(".", "")
      .replaceAll("/", "");
    localStorage.setItem("user", CryptoJS.AES.encrypt(username, "MedSys@341"));
    let url = server + "login_portal";

    const controller = new AbortController();
    const timeoutId = setTimeout(() => controller.abort(), 10000);

    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: username,
        senha: data.get("senha"),
      }),
      signal: controller.signal,
    })
      .then((resp) => {
        clearTimeout(timeoutId);

        if (!resp.ok) {
          throw new Error(`Erro no servidor: Status ${resp.status}`);
        }
        return resp.json();
      })
      .then((reqres) => {
        closeModal();
        setLoading(false);

        if (reqres.JSONID) {
          localStorage.setItem("token", reqres.JSONID);
          Cookies.set("bearer", reqres.bearer);
          Cookies.set("codparc", reqres.codparc);
          localStorage.setItem("changepass", reqres.trocasenha);
          localStorage.setItem("canfield", reqres.canfield);
          localStorage.setItem("segmento", reqres.segmento);
          localStorage.setItem(
            "nomeparc",
            CryptoJS.AES.encrypt(reqres.nomeparc, "MedSys@341"),
          );
          localStorage.setItem(
            "med",
            CryptoJS.AES.encrypt(data.get("senha"), "MedSys@341"),
          );
          localStorage.setItem("username", username);
          window.location.href = "/portal/dashboard";
        } else {
          setModalButtons(<Button onClick={closeModal}>Fechar</Button>);
          setShowCnpjField(false);
          openModal();
          setDescricao(modalData.erro);
        }
      })
      .catch((error) => {
        clearTimeout(timeoutId);

        setLoading(false);

        if (error.name === "AbortError") {
          openModal();
          setDescricao(
            "A conexão demorou muito para responder. Por favor, verifique sua internet.",
          );
        } else {
          openModal();
          setDescricao(
            "Não foi possível conectar ao servidor. Tente novamente mais tarde.",
          );
        }
        console.error("Erro no fluxo de login:", error);
      });
  }, []);

  const closeModalNovo = () => setOpenNovo(false);

  const handeChangePass = () => {
    setDescricao(modalData.recupera_senha);
    openModal();
    setShowCnpjField(true);
    setModalButtons(
      <>
        <Button onClick={closeModal}>Cancelar</Button>
        <Button
          onClick={() => {
            closeModal();
            handleEnviarEmail();
          }}
        >
          OK
        </Button>
      </>,
    );
  };

  const handleEnviarEmail = () => {
    let url = server + "login_portal";
    fetch(url, {
      method: "POST",
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        username: perdiSenhaCNPJ,
        esquecesenha: true,
      }),
    })
      .then((resp) => resp.text())
      .then((reqres) => {
        let resp = JSON.parse(reqres);
        setModalButtons(<Button onClick={closeModal}>OK</Button>);
        setShowCnpjField(false);
        if (resp.data === undefined) {
          setDescricao(modalData.cnpj_nao_reg);
          openModal();
        } else {
          setDescricao(modalData.email_enviado);
          openModal();
        }
      });
  };

  return (
    <ThemeProvider theme={theme}>
      <Dialog
        open={openNovo}
        hasCloseButton
        onClose={closeModalNovo}
        style={{ maxWidth: "100%", maxHeight: "100%" }}
      >
        <DialogTitle
          disableTypography
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Box
            component="img"
            src={LogoLogin}
            sx={{
              bgcolor: "white",
              width: 85,
              height: 36,
            }}
          ></Box>
          <IconButton onClick={closeModalNovo}>
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        <MediaQuery orientation="portrait">
          <img
            style={{ width: "auto", height: "27vh", objectFit: "contain" }}
            src={popImg}
            alt="image"
          />
        </MediaQuery>

        <MediaQuery orientation="landscape">
          <img
            style={{ width: "auto", height: "60vh", objectFit: "contain" }}
            src={popImg}
            alt="image"
          />
        </MediaQuery>
      </Dialog>

      <Dialog open={open} onClose={closeModal}>
        <DialogTitle>Atenção</DialogTitle>
        <DialogContent>
          <DialogContentText>{descricao}</DialogContentText>
          {showCnpjField && (
            <TextField
              autoFocus
              margin="dense"
              id="cnpj"
              label="Digite o seu CNPJ/CPF"
              type="cnpj"
              onChange={(e) => setPerdiSenhaCNPJ(e.target.value)}
              fullWidth
              variant="standard"
            />
          )}
        </DialogContent>
        <DialogActions>{modalButtons}</DialogActions>
      </Dialog>

      <Grid
        container
        component="main"
        sx={{ height: "100vh", overflow: "hidden" }}
      >
        <CssBaseline />
        <Grid
          item
          xs={false}
          sm={4}
          md={7}
          sx={{
            backgroundImage: `url(${BKGLogin})`,
            backgroundRepeat: "no-repeat",
            backgroundColor: (t) =>
              t.palette.mode === "light"
                ? t.palette.grey[50]
                : t.palette.grey[900],
            backgroundSize: "cover",
            backgroundPosition: "center",
          }}
        />
        <Grid
          item
          xs={12}
          sm={8}
          md={5}
          component={Paper}
          elevation={6}
          square
          sx={{ overflow: "auto", maxHeight: "100vh" }}
        >
          <Box
            sx={{
              my: 4,
              mx: 4,
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
            }}
          >
            <MediaQuery orientation="portrait">
              <Box
                component="img"
                src={LogoLogin}
                sx={{ m: 1, bgcolor: "white", width: 100, height: 43 }}
              ></Box>
            </MediaQuery>

            <MediaQuery orientation="landscape">
              <Box
                component="img"
                src={LogoLogin}
                sx={{ m: 1, bgcolor: "white", width: 200, height: 79 }}
              ></Box>
            </MediaQuery>

            <Typography component="h1" variant="h5">
              Entre com o seu CNPJ-CPF
            </Typography>

            <Box
              component="form"
              noValidate
              onSubmit={handleSubmit}
              sx={{ width: "100%" }}
            >
              <TextField
                margin="normal"
                required
                fullWidth
                id="cnpj"
                label="CNPJ/CPF"
                name="cnpj"
                autoComplete="cnpj"
                autoFocus
              />
              <TextField
                margin="normal"
                required
                fullWidth
                name="senha"
                label="Senha"
                type={showPassword ? "text" : "password"}
                id="password"
                autoComplete="current-password"
                InputProps={{
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setShowPassword(!showPassword)}
                        edge="end"
                      >
                        {showPassword ? (
                          <VisibilityOffIcon />
                        ) : (
                          <RemoveRedEyeIcon />
                        )}
                      </IconButton>
                    </InputAdornment>
                  ),
                }}
              />
              <LoadingButton
                loading={loading}
                type="submit"
                fullWidth
                variant="contained"
                sx={{ mt: 2, mb: 1 }}
              >
                Entrar
              </LoadingButton>
              <Grid container>
                <Grid item xs>
                  <Link href="#" onClick={handeChangePass} variant="body2">
                    Esqueci a senha
                  </Link>
                </Grid>
                <Grid item>
                  <Link
                    href="/portal/faq"
                    variant="body2"
                    target="_blank"
                    rel="noreferrer"
                  >
                    Acesse as principais dúvidas
                  </Link>
                </Grid>
              </Grid>

              <Grid container spacing={1} sx={{ mt: 1 }}>
                <Grid item xs={12} sx={{ textAlign: "center" }}>
                  <Typography
                    variant="h6"
                    sx={{
                      fontWeight: 600,
                      color: "primary.main",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <SupportIcon sx={{ mr: 1 }} />
                    Atendimento
                  </Typography>
                </Grid>

                <Grid
                  item
                  xs={12}
                  sx={{ display: "flex", flexDirection: "column", gap: 1 }}
                >
                  <Button
                    startIcon={<SupportIcon />}
                    variant="outlined"
                    size="small"
                    href={`https://wa.me/${supportNumber.whatsApp}`}
                    target="_blank"
                    sx={{
                      justifyContent: "flex-start",
                      textTransform: "none",
                    }}
                  >
                    Suporte ao Cliente
                  </Button>
                  <Button
                    startIcon={<BuildIcon />}
                    variant="outlined"
                    size="small"
                    href={`https://wa.me/${supportNumber.whatsApp}`}
                    target="_blank"
                    sx={{
                      justifyContent: "flex-start",
                      textTransform: "none",
                    }}
                  >
                    Assistência Técnica
                  </Button>
                  <Button
                    startIcon={<ShoppingCartIcon />}
                    variant="outlined"
                    size="small"
                    href={`https://wa.me/${supportNumber.whatsApp}?text=Ol%C3%A1%21+Gostaria+de+falar+sobre+os+consum%C3%ADveis`}
                    target="_blank"
                    sx={{
                      justifyContent: "flex-start",
                      textTransform: "none",
                    }}
                  >
                    Comprar Consumíveis
                  </Button>
                  <Button
                    startIcon={<PhoneIcon />}
                    variant="outlined"
                    size="small"
                    href={`tel:+${supportNumber.whatsApp}`}
                    sx={{
                      justifyContent: "flex-start",
                      textTransform: "none",
                    }}
                  >
                    {supportNumber.phone}
                  </Button>
                </Grid>
              </Grid>
              <Copyright sx={{ mt: 5 }} />
            </Box>
          </Box>
        </Grid>
      </Grid>
    </ThemeProvider>
  );
};

export default SignInSide;
